import { useAuth } from '@/modules/context/AuthContext'
import { noDaycareRights } from '@/modules/context/daycareRights'
import { DaycareRights } from '@/types/Context'

export function useDaycareRight<K extends keyof DaycareRights>(right: K): DaycareRights[K] {
    const { user } = useAuth()
    return (user?.currentDaycareRights ?? noDaycareRights)[right]
}
